import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import styled from '@emotion/styled';
import { __ } from '../helpers/TranslationService';

import { GuaranteeIcon } from './Icons/newIcons/GuaranteeIcon';
import { Modal } from './Modal';
import { softBlack } from '../consts/variables';
import { BreakpointsEnum } from '../helpers/breakpoints';

const StyledModal = styled(Modal)`
    .modalContent {
        max-width: 720px;
        text-align: left;
        padding: 36px;
        color: ${softBlack};
        width: 100%;

        & > .modalClose {
            top: 36px;
            right: 36px;
        }
    }
`;

const ModalTitle = styled.h3`
    font-size: 20px;
    margin-top: 0;
    margin-bottom: 0;
`;

const ModalBody = styled.p`
    margin-top: 24px;
    margin-bottom: 0;
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    margin-top: 24px;

    @media (max-width: ${BreakpointsEnum.md}) {
        margin-top: 0;
        margin: 0 15px 15px;
    }
`;

const LearnMoreButton = styled.button`
    color: ${({ theme }) => theme.link.primary};
    text-decoration: underline;
    background: none;
    border: none;
    padding: 0;
`;

const LabelWrapper = styled.div``;

const Label = styled.p`
    color: ${softBlack};
    margin: 0;
    margin-right: 16px;
    display: inline;
`;

const StyledGuaranteeIcon = styled(GuaranteeIcon)`
    fill: ${({ theme }) => theme.icon.brandColor1};
    margin-right: 8px;
    flex-shrink: 0;
`;

export const GuaranteeCabinLabel = () => {
    const [showModal, setShowModal] = useState(false);

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleMoreInfoClick = (e: any) => {
        e.preventDefault();
        setShowModal(true);
    };

    return (
        <>
            <Wrapper>
                <StyledGuaranteeIcon width={20} height={20} />
                <LabelWrapper>
                    <Label>{__('guaranteeCabin.label', 'dreamlines')}</Label>
                    <LearnMoreButton className="guaranteeCabin__link" onClick={handleMoreInfoClick}>
                        {__('learnMore', 'dreamlines')}
                    </LearnMoreButton>
                </LabelWrapper>
            </Wrapper>

            {showModal &&
                createPortal(
                    <StyledModal isOpen={true} onClose={handleModalClose}>
                        <>
                            <ModalTitle>{__('guaranteeCabin.modalTitle', 'dreamlines')}</ModalTitle>
                            <ModalBody>{__('guaranteeCabin.modalBody', 'dreamlines')}</ModalBody>
                        </>
                    </StyledModal>,
                    document.body,
                )}
        </>
    );
};
